import * as React from 'react';

import {LoadingPage} from 'shells/loading-page/loading-page';

import {CompetitorsCharts} from './competitors-charts';
import {NeedToConfigureEmptyState} from './empty-states';
import {useIsCompetitorIqConfigured} from './graphql/hooks';

type Props = {
    onGoToSettings: () => void;
};

export function CompetitorsChartsWrapper(props: Props) {
    const {isDomainConfigured, areCompetitorsConfigured, isLoading} = useIsCompetitorIqConfigured();

    if (!isLoading && (!isDomainConfigured || !areCompetitorsConfigured)) {
        const getTodoText = () => {
            if (isDomainConfigured) {
                return 'Add at least one competitor to start tracking and comparing your traffic';
            } else if (areCompetitorsConfigured) {
                return 'Add your domain to start tracking and comparing your traffic';
            } else {
                return 'Add your domain and at least one competitor to start tracking and comparing your traffic';
            }
        };

        const getButtonText = () => {
            if (isDomainConfigured) {
                return 'Add competitors';
            } else if (areCompetitorsConfigured) {
                return 'Add domain';
            } else {
                return 'Set up now';
            }
        };

        return (
            <NeedToConfigureEmptyState
                todoText={getTodoText()}
                buttonText={getButtonText()}
                onClick={() => {
                    props.onGoToSettings();
                }}
            />
        );
    }

    return <>{isLoading ? <LoadingPage /> : <CompetitorsCharts />}</>;
}
